import {createRoot} from "react-dom/client";
import ErrorBanner from "../components/ErrorBanner";

export function showError(message: string) {
    const errorBanner = document.createElement('div') as HTMLElement;
    const el = createRoot(errorBanner);

    el.render(ErrorBanner({message: message}));

    document.getElementById('errors')?.appendChild(errorBanner);
}